import { externalApi } from '../../shared/config/axiosConfig';

/**
 * Issues one short-lived pairing code for current browser user and manager device.
 * @param {string} deviceId stable manager installation identifier
 * @returns {Promise<{code: string, expiresIn: number}>}
 */
export const issueManagerPairingCode = async (deviceId) => {
  const response = await externalApi({
    method: 'POST',
    url: '/auth/manager/pairing-code',
    data: { deviceId },
  });
  const result = response?.data?.Result;
  if (
    !result ||
    typeof result.code !== 'string' ||
    typeof result.expiresIn !== 'number' ||
    result.expiresIn <= 0
  ) {
    throw new Error('Pairing-code response did not contain required fields');
  }
  return result;
};
